import { Component, Input } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-stackedbarchart',
  templateUrl: './stackedbarchart.component.html',
  styleUrls: ['./stackedbarchart.component.scss'],
})
export class StackedbarchartComponent {
  @Input() data: any;
  options: any;

  startDate: Date  = new Date('09-09-2023');
  endDate: Date = new Date();
  today: Date = new Date();
  graphData: any;
  chartData: any;

  chartOptions: any = {
    maintainAspectRatio: false,
    aspectRatio: 0.8,
    plugins: {
      tooltips: {
        mode: 'index',
        intersect: false,
      },
    },
    scales: {
      x: {
        stacked: true,
        grid: {
          drawBorder: false,
        },
      },
      y: {
        stacked: true,
        grid: {
          drawBorder: false,
        },
      },
    },
  };

  usedColors: string[] = [];

  constructor(private dataService: DataService) {}

  async ngOnInit(): Promise<void> {
    // Format your MongoDB data here
    const rawData = await this.getDataFromArg(this.data);

    // Prepare data for the Stacked Bar Chart
    this.chartData = {
      labels: rawData.map((item: any) => item._id),
      datasets: rawData[0].data.map((data: any) => ({
        label: data.key,
        data: rawData.map(
          (item: any) =>
            item.data.find((r: any) => r.key === data.key)?.count || 0
        ),
        backgroundColor: this.getUniqueColor(), // Function to get a unique color
      })),
    };

    // Set options for the chart (customize as needed)
    this.options = {
      title: {
        display: true,
        text: this.data.graphname,
        fontSize: 16,
      },
      scales: {
        xAxes: [{ stacked: true }],
        yAxes: [{ stacked: true }],
      },
    };

    this.chartOptions = {
      maintainAspectRatio: false,
      aspectRatio: 0.8,
      plugins: {
        tooltips: {
          mode: 'index',
          intersect: false,
        },
        legend: {
          labels: {
            font: {
              size: 14,
              family: 'SSTArabic',
            },color :'white'
          },
        },
      },
      scales: {
        x: {
          stacked: true,
          grid: {
            drawBorder: false,
          },
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic',
            }, color :'white'
          },
        },
        y: {
          stacked: true,
          grid: {
            drawBorder: false,
          },
          ticks: {
            font: {
              size: 12,
              family: 'SSTArabic',
            },color :'white'
          },
        },
      },
    };
  }

  async getDataFromArg(data: any, startDate?: Date, endDate?: Date) {
    let managerOu: any = localStorage.getItem('managerOus');

    managerOu = managerOu ? JSON.parse(managerOu) : null;

    if (data.tag && data.tag === 'MANAGER' && managerOu && managerOu.length > 0) {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          timeRange: (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
          managerOus: managerOu
        }
      );
      return res.data;
    } else {
      let res = await this.dataService.postData(
        'dashboards/dynamic-aggregation',
        {
          aggregation: data.aggregation,
          tableName: data.table,
          timeRange:  (startDate && endDate) ? { startDate: startDate, endDate: endDate } : null,
        }
      );
      return res.data;
    }
  }

  getUniqueColor() {
    const colors = [
      '#6648FF',
      '#703D94',
      '#F7517F',
      '#FACB7D',
      '#3F4357',
      '#16CEB9',
      '#FACB7D',
      '#FF6384',
      '#18C4B1',
      '#2a0450',
      '#082f4e',
      '#011941',
      '#110d49',
    ];

    // Check if all colors have been used, reset the usedColors array
    if (this.usedColors.length === colors.length) {
      this.usedColors = [];
    }

    // Find a color that hasn't been used yet
    let color = '';
    for (const c of colors) {
      if (!this.usedColors.includes(c)) {
        color = c;
        this.usedColors.push(c);
        break;
      }
    }

    return color;
  }

  async makeChart(rawData: any) {
    return {
      labels: rawData.map((item: any) => item._id),
      datasets: rawData[0].data.map((data: any) => ({
        label: data.key,
        data: rawData.map(
          (item: any) =>
            item.data.find((r: any) => r.key === data.key)?.count || 0
        ),
        backgroundColor: this.getUniqueColor(), // Function to get a unique color
      })),
    };
  }

  async onDateChange() {
    this.graphData = await this.getDataFromArg(this.data, this.startDate, this.endDate);
    this.chartData = await this.makeChart(this.graphData)
  }
}
